import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import {
    IGetCatchUpEpisodeDetailResponse,
    IGetCatchUpEpisodeDetailParams,
} from '../../../entity/interface/iMpxVodResponse';
import { IMpxRepository } from '../../repositories/interfaces/IMpxRepository';

export interface IGetCatchUpEpisodeDetailUseCase {
    execute(params: IGetCatchUpEpisodeDetailParams): Promise<IGetCatchUpEpisodeDetailResponse>;
}

export class GetCatchUpEpisodeDetailUseCase implements IGetCatchUpEpisodeDetailUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get mpxRepository(): IMpxRepository {
        return container.resolve<IMpxRepository>(DI.REPOSITORIES.IMpxRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(params: IGetCatchUpEpisodeDetailParams): Promise<IGetCatchUpEpisodeDetailResponse> {
        return this.mpxRepository.getCatchUpEpisodeDetail(params);
    }
}
